export const getCheckoutAccessTypeLabel = (enabledHdPass) =>
  enabledHdPass ? 'HD Pass' : 'Virtual ID';
